import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { currentEpisodeActions } from "../../actions";
import { isLogged, modalPaths } from "../ScrollReader/helpers";

import { UnlockConfirm } from "../design/unlocking/UnlockConfirm";

import RedirectWhen from "../utils/RedirectWhen.js";
import Modal from "../Modal.js";

export const UNLOCK_MODAL_SIZE = {
  width: "468px",
  height: "635px"
};

class UnlockConfirmModal extends React.Component {
  handleUnlock = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onConfirmClick(this.props.episodeId);
  };

  render() {
    const { ready, blockModal, ...confirmProps } = this.props;
    return (
      <RedirectWhen when={!blockModal && !isLogged()} to={modalPaths.signIn}>
        {(ready || blockModal) ? (
          <RedirectWhen when={!blockModal && !confirmProps.canUnlock} to="">
            <Modal {...UNLOCK_MODAL_SIZE} success={true}>
              <UnlockConfirm
                {...confirmProps}
                onConfirmClick={this.handleUnlock}
              />
            </Modal>
          </RedirectWhen>
        ) : null}
      </RedirectWhen>
    );
  }
}

const mapState = (state, ownProps) => {
  const userBalance =
    state.currentUser.wallets &&
    parseFloat(
      state.currentUser.wallets.find(wallet => wallet.currency === "pc1")
        .balance
    );
  const canUnlock =
    state.currentEpisode.episode.premium &&
    !state.currentEpisode.episode.paid &&
    state.currentEpisode.episode.price <= userBalance;

  return {
    episodeId: state.currentEpisode.id,
    episodePrice: state.currentEpisode.episode.price,
    episodeTitle: state.currentEpisode.title,
    storyTitle: state.currentEpisode.story_title,
    t: I18n.t("components.unlockConfirmModal"),
    userBalance,
    canUnlock
  };
};

const mapDispatch = dispatch => ({
  onConfirmClick: episodeId => {
    dispatch(currentEpisodeActions.unlockEpisode(episodeId));
  }
});

export default connect(mapState, mapDispatch)(UnlockConfirmModal);
